import styled from 'styled-components'

const StyledCaptionsView = styled.div`
  
`

export default StyledCaptionsView
